// react-router-dom components
import { Link, useNavigate } from 'react-router-dom';

// prop-types is a library for typechecking of props.
import PropTypes from 'prop-types';

// @mui material components
import { Breadcrumbs as MuiBreadcrumbs } from '@mui/material';
import Icon from '@mui/material/Icon';
import HomeIcon from '@mui/icons-material/Home';
//  React components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import { useSelector } from 'react-redux';

const breadcrumbsLabels = ['', '', '', 'Customer:', 'Building:', 'Floor:', 'Area:'];

function Breadcrumbs({ icon, title, route, light, showRoutsNav = true }) {
  const devicesNames = useSelector(state => state.sensors.names) || {}; // ✅ Add fallback
  const routes = route?.slice(0, -1) || []; // ✅ Add null check
  const navigate = useNavigate();

  const handleClick = index => {
    const newPath = routes.slice(0, index + 1).join('/');
    navigate(`/${newPath}`);
  };

  return (
    <MDBox mr={{ xs: 0, xl: 8 }} sx={{ width: '100%' }}>
      <MuiBreadcrumbs
        sx={{
          display: 'flex',
          justifyContent: { xs: 'center', sm: 'flex-start' },
          '& .MuiBreadcrumbs-ol': {
            justifyContent: { xs: 'center', sm: 'flex-start' },
            flexWrap: 'wrap',
          },
          '& .MuiBreadcrumbs-separator': {
            color: ({ palette: { white, grey } }) => (light ? white.main : grey[600]),
          },
        }}>
        <Link to="/">
          <MDTypography
            component="span"
            variant="body2"
            color={light ? 'white' : 'dark'}
            opacity={light ? 0.8 : 0.5}
            sx={{ lineHeight: 0 }}>
            <HomeIcon></HomeIcon>
          </MDTypography>
        </Link>
        {showRoutsNav &&
          routes
            ?.filter(i => i !== 'data-explorer') // ✅ Add optional chaining
            .map((el, index) => (
              <MDTypography
                key={el}
                component="span"
                variant="button"
                sx={{
                  cursor: 'default',
                  lineHeight: 0,
                }}>
                {`${breadcrumbsLabels[index] || ''} ${el?.replace(/%20|-/g, ' ') || ''}`} {/* Add fallbacks */}
              </MDTypography>
            ))}
        <MDTypography
          variant="button"
          fontWeight="regular"
          textTransform="capitalize"
          color={light ? 'white' : 'dark'}
          sx={{ lineHeight: 0 }}>
          {breadcrumbsLabels[routes?.length] || ''} {/* Add fallback */}
          {devicesNames && title && devicesNames[title] // Add null checks
            ? `${title}: ${devicesNames[title]}`
            : title?.replace(/%20|-/g, ' ') || ''}{' '}
          {/* Add null checks */}
        </MDTypography>
      </MuiBreadcrumbs>
    </MDBox>
  );
}

// Setting default values for the props of Breadcrumbs
Breadcrumbs.defaultProps = {
  light: false,
};

// Typechecking props for the Breadcrumbs
Breadcrumbs.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  route: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  light: PropTypes.bool,
};

export default Breadcrumbs;
